import React, { useEffect, useState, useRef } from 'react';
import propTypes from 'prop-types';
import styled, { keyframes, css } from 'styled-components';
import { theme } from '../../../themes/default-theme';
import Link from 'next/link';
import { useRouter } from 'next/router';

const rotate1 = keyframes`
  from {
    margin-left: 100%;
  }
  to {
    margin-left: 0;
  }
`;
const rotate2 = keyframes`
  from {
    margin-left: -100%;
  }
  to {
    margin-left: 0;
  }
`;

const Wrapper = styled.div`

`

const Container = styled.div`
 
`

const StepsContainer = styled.div`
    display: flex;
    width: 100%;
    ${theme.breakpoints.up('md')} { 
        max-width: 445px;
        height: 29px;
    }
    ${theme.breakpoints.down('sm')} { 
        height: 26px;
    }
`

const StepContainer = styled.div`
    width: 20%; 
    position: relative;  
    border-bottom: 4px solid ${theme.palette.middleGrey};    
    &:after {
        animation: none;
        content: none;
        position: absolute;
        top: 100%;
        width: 100%;
        height: 4px;
        left: 0;
        background: ${theme.palette.vividBlue};
    }

    text-align: center;
    position: relative;
    > a, > span {
        font-size: 15px;
        text-align: center;
        text-transform: capitalize;
        text-decoration: none;
        font-weight: 700;
        display: block;
        width: 100%;
        height: 100%;
        color: #758094;
    }
    > span {
        &:nth-child(2) {
            position: absolute;
            margin-top: 10px;
        }
    }
    &:after {
        animation: ${props => ((props.animation === 'toLeft' && props.activeButton == 1) ? css`${rotate1} 0.3s` : (props.animation === 'toRight' && props.activeButton == 1) && css`${rotate2} 0.3s`)}
    }

    ${props => props.animation == 'toLeft' && props.activeButton == 1 && `
        > a {
            transition: color 0.3s linear;
            color: ${theme.palette.vividBlue};
        }
        &:after {
            content: '';
            top: 100%;
        }
    `}
    ${props => props.animation == 'toRight' && props.activeButton == 1 && `
        > a {
            transition: color 0.3s linear;
            color: ${theme.palette.vividBlue};
        }
        &:after {
            content: '';
            top: 100%;
        }
    `}
    ${props => !props.animation && !props.activeButton && props.active == 1 && `
        > a {
            color: ${theme.palette.vividBlue};
        }
        &:after {
            content: '';
            background: ${theme.palette.vividBlue};
        }
    `}
    ${props => !props.animation && props.active == 1 && (props.activeButton == props.active) && `
    > a {
        color: ${theme.palette.vividBlue};
    }
    &:after {
        content: '';
        background: ${theme.palette.vividBlue};
    }
`}
`

const ModelStepsCounter = (props) => {

    const {
        modelStepsData,
        handleSaveData
    } = props;

    const [activeStep, setActiveStep] = useState(null);
    const [otherActiveStep, setOtherActiveStep] = useState(null);
    const [animation, setAnimation] = useState(null);
    const [disabledStepMsg, setDisabledStepMsg] = useState(false);
    const router = useRouter();
    const previousValue = useRef(null);
    const handleDisabledStep = (e) => {
        e.preventDefault();
        setDisabledStepMsg(true);
        setTimeout(() => {
            setDisabledStepMsg(false);
        }, 3000)
    }


    const handleClick = (e, index, item) => {
        e.preventDefault();
        handleSaveData();
        setOtherActiveStep(index);
        if ((index > (activeStep && activeStep) && (!previousValue.current || index > previousValue.current))) {
            setAnimation('toRight');
        } else if ((previousValue.current) && (index < previousValue.current)) {
            setAnimation('toLeft');
        } else if ((previousValue.current) && (index > previousValue.current)) {
            setAnimation('toRight');
        } else if (index < (activeStep && activeStep)) {
            setAnimation('toLeft');
        }
        router.push(item);
    }


    useEffect(() => {
        previousValue.current = otherActiveStep;
    }, [otherActiveStep]);

    useEffect(() => {
        if (modelStepsData?.active) {
            setActiveStep(modelStepsData.active)
        } else {
            setActiveStep(1)
        }
    }, [modelStepsData])

    return (
        <Wrapper>
            <Container>
                {modelStepsData && modelStepsData.steps && modelStepsData.steps.length > 0 &&
                    <StepsContainer>
                        {modelStepsData.steps.map((item, index) => {
                            return (
                                <StepContainer key={index} active={(index + 1) == (activeStep && activeStep) ? 1 : 0} animation={animation ? animation : null} activeButton={otherActiveStep == (index + 1) ? 1 : 0}>
                                    {item.disabled ?
                                        <>
                                            <span onClick={(e) => { handleDisabledStep(e) }}>
                                                {item.step}
                                            </span>
                                            {disabledStepMsg &&
                                                <span>
                                                </span>
                                            }
                                        </>
                                        :
                                        <Link href={(item.url && !item.disabled) ? item.url : nul}>
                                            <a onClick={(e) => handleClick(e, (index + 1), (item.url && !item.disabled) ? item.url : null)}>
                                                {item.step}
                                            </a>
                                        </Link>
                                    }
                                </StepContainer>
                            )
                        })
                        }
                    </StepsContainer>
                }
            </Container>
        </Wrapper>
    )
}

ModelStepsCounter.propTypes = {
    modelStepsData: propTypes.object,
    handleSaveData: propTypes.func
}

ModelStepsCounter.defaultProps = {
    modelStepsData: {},
    handleSaveData: () => { }
}

export default ModelStepsCounter